import { editorStub as state } from '@/store/editor/stub';
import getters from '@/store/editor/getters';
import mutations from '@/store/editor/mutations';
import actions from '@/store/editor/actions';
import type { editor } from '@/store/editor/types';
import type { Module } from 'vuex';
import type { RootState } from '..';

const editorState: Module<editor, RootState> = {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters,
};
export default editorState;
